import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-rep-finanzas',
  templateUrl: './rep-finanzas.component.html',
  styleUrls: ['./rep-finanzas.component.scss']
})
export class RepFinanzasComponent{

  constructor(private loginService:LoginService) { }

  clickGuard(){
    this.loginService.clickGuard = true;
 }

}
